import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import { deepClone } from '@/utils';
import apis from '@/apis/caseManage';
import BreadcrumbHeader from '../Layout/BreadcrumbHeader.vue';
import MemberInfoForm from './components/MemberInfoForm/index.vue';
import BaseInfoForm from './components/BaseInfoForm.vue';
import ScheduleCase from './components/ScheduleCase.vue';
import UploadEvidents from './components/UploadEvidents.vue';

var CaseEdit = /*#__PURE__*/function (_Vue) {
  _inherits(CaseEdit, _Vue);

  var _super = _createSuper(CaseEdit);

  function CaseEdit() {
    var _this;

    _classCallCheck(this, CaseEdit);

    _this = _super.apply(this, arguments);
    _this.dic = _this.$store.getters.dic;
    _this.userInfo = _this.$store.getters.userInfo;
    _this.activeStep = 0;
    _this.nowCaseId = '';
    _this.litigationStatusIdOptions = [];
    _this.isSubmitting = false;
    return _this;
  } // 审判程序改变时，请求诉讼地位


  _createClass(CaseEdit, [{
    key: "handleTrialProgramChange",
    value: function handleTrialProgramChange(parentId) {
      var _this2 = this;

      apis.trialProgramTree({
        parentId: parentId
      }).then(function (res) {
        _this2.litigationStatusIdOptions = res.data;
      }).catch(function (_) {
        _this2.litigationStatusIdOptions = [];
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.$router.go(-1);
    }
  }, {
    key: "toPrevStep",
    value: function toPrevStep() {
      var t = this.activeStep - 1;
      this.activeStep = t < 0 ? 0 : t;
    }
  }, {
    key: "toNextStep",
    value: function toNextStep(isSubmit) {
      if (isSubmit) {
        this.$router.go(-1);
      } else {
        var t = this.activeStep + 1;
        this.activeStep = t > 3 ? 3 : t;
      }
    } // 处理点击下一步或提交按钮

  }, {
    key: "handleNextStep",
    value: function handleNextStep(isSubmit) {
      var _this3 = this;

      switch (this.activeStep) {
        case 0:
          this.$refs.baseInfoForm.handleSubmit(function (valid) {
            return valid && _this3.toNextStep(isSubmit);
          });
          break;

        case 1:
          this.submitBase(isSubmit);
          break;

        case 2:
          this.submitSchedule(isSubmit);
          break;

        case 3:
          this.submitEvident(isSubmit);
          break;

        default:
          break;
      }
    }
  }, {
    key: "submitBase",
    value: function () {
      var _submitBase = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(isSubmit) {
        var _yield$this$saveBase, code, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.isSubmitting = true; // 取得新建的案件id，传给排期组件

                _context.next = 4;
                return this.saveBase();

              case 4:
                _yield$this$saveBase = _context.sent;
                code = _yield$this$saveBase.code;
                data = _yield$this$saveBase.data;

                if (code === '0') {
                  this.nowCaseId = data;
                  this.$message.success('新建案件成功');
                  this.toNextStep(isSubmit);
                }

                this.isSubmitting = false;
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                this.isSubmitting = false;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function submitBase(_x) {
        return _submitBase.apply(this, arguments);
      }

      return submitBase;
    }()
  }, {
    key: "submitSchedule",
    value: function submitSchedule(isSubmit) {
      var _this4 = this;

      var scheduleCaseRef = this.$refs.scheduleCase;

      var initHandler = function initHandler() {
        _this4.isSubmitting = true;
      };

      var resolveHandler = function resolveHandler() {
        _this4.$message.success('新建排期成功');

        _this4.toNextStep(isSubmit);

        _this4.isSubmitting = false;
      };

      var rejectHandler = function rejectHandler() {
        _this4.isSubmitting = false;
      };

      scheduleCaseRef.handleSubmit(initHandler, resolveHandler, rejectHandler);
    }
  }, {
    key: "submitEvident",
    value: function submitEvident(isSubmit) {
      this.toNextStep(isSubmit);
    } // 保存基本信息, 返回 Promise
    // 因为需要在本组件汇总两表数据

  }, {
    key: "saveBase",
    value: function saveBase() {
      var baseInfo = this.$refs.baseInfoForm.baseInfoForm; // console.log('基本信息', baseInfo)
      // 案由多选兼容配置-start

      baseInfo.caseReasonId = baseInfo.caseReasonIds.datas.map(function (val) {
        return val.id;
      }).join(';');
      baseInfo.caseReasonName = baseInfo.caseReasonIds.datas.map(function (val) {
        return val.caseActionName;
      }).join(';'); // 案由多选兼容配置-end

      var _this$$refs$memberInf = this.$refs.memberInfoForm,
          clientList = _this$$refs$memberInf.clientList,
          proxyList = _this$$refs$memberInf.proxyList; // 拷贝

      var partyList = deepClone(clientList);
      var procuratorList = deepClone(proxyList);
      var params = Object.assign({
        partyList: partyList,
        procuratorList: procuratorList
      }, baseInfo); // 处理立案时间

      params.registerTime = params.registerTime.toLocaleDateString().split('/').join('-'); // 处理默认及非默认案号

      if (params.defaultType) {
        var caseNoYearObject = this.dic.yearList.find(function (item) {
          return item.value === params.caseNoYear;
        });
        var caseNoTypeObject = this.dic.caseCodeList.find(function (item) {
          return item.value === params.caseNoTypeId;
        });
        params.caseNoAll = "".concat(caseNoYearObject.label).concat(params.courtCode).concat(caseNoTypeObject.label).concat(params.caseNoNum, "\u53F7");
      } else {
        params.caseNoYear = '';
        params.caseNoTypeId = '';
        params.caseNoNum = '';
      } // 处理 party uuid


      params.procuratorList.forEach(function (procurator) {
        procurator.partyUuid = procurator.dldx.map(function (dldx) {
          return dldx.uuid;
        }).join();
      }); // 添加法院编码

      params.courtNo = this.userInfo.courtNo; // 案由多选兼容配置-start

      delete params.caseReasonIds; // 案由多选兼容配置-end

      return apis.saveCase(params);
    }
  }]);

  return CaseEdit;
}(Vue);

__decorate([Prop()], CaseEdit.prototype, "id", void 0);

CaseEdit = __decorate([Component({
  components: {
    BaseInfoForm: BaseInfoForm,
    BreadcrumbHeader: BreadcrumbHeader,
    MemberInfoForm: MemberInfoForm,
    ScheduleCase: ScheduleCase,
    UploadEvidents: UploadEvidents
  }
})], CaseEdit);
export default CaseEdit;